import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PeriButton from "../Components/Button";
import '../style/peri-check.css'
import { useTranslation } from "react-i18next";
import back from "../../../assets/Icons/Back-white.png"
import tick from "../../../assets/Icons/peri-tickmark.png"
import close from "../../../assets/Icons/close-white.png"

const LandingPage4 = () => {
    const { t, i18n } = useTranslation("l2")

    const navigate = useNavigate();

    return (
        <div className="relative w-full h-full landing-page4-container">

            {/* Top Buttons - Ensure higher z-index */}
            <div className="absolute top-0 left-0 w-full z-30 px-2 pt-2">
                <div className="flex justify-between items-center h-13">
                    <button type="button" onClick={() => navigate('/expert/landing-page-2')}>
                        <img src={back} alt="back" className="w-8 h-8" />
                    </button>
                    <button type="button" onClick={() => navigate('/expert/landing-page-1')}>
                        <img src={close} alt="close" className="w-12 h-12" />
                    </button>
                </div>
            </div>

            {/* Centered Modal */}
            <div className="absolute inset-0 flex items-center justify-center z-20 px-2">
                <div className="bg-white w-80 text-black px-4 py-2 rounded-lg shadow-lg">
                    <div className="cera-pro-black font-semibold uppercase pt-4">Janji Privasi</div>
                    <div className="text-peri-primary font-bold pb-2">FOTO ANDA TIDAK AKAN DISIMPAN</div>
                    <p className="py-1 text-xs cera-pro-black">
                        <span className="text-black font-bold">A.I Analisa Gusi:</span> pengalaman yang didukung oleh kecerdasan buatan (AI) dan tidak menggantikan nasihat profesional.Hasil mungkin berbeda-beda tergantung kulit masing-masing individu dan kualitas gambar yang masuk serta kondisi pencahayaan.
                    </p>
                    <p className="py-1 text-xs cera-pro-black">
                        <span className="text-black font-bold">Kami tidak akan pernah menyimpan foto Anda.</span> Foto Anda hanya digunakan untuk analisis kulit dan akan segera dihapus setelahnya. Kami hanya menggunakan data pribadi untuk memberikan Anda hasil analisis kesehatan gusi dan rekomendasi produk Anda.
                    </p>
                    <p className="py-1 text-xs cera-pro-black">
                        <img src={tick} alt="tick" className="w-3 h-3 mr-1 inline-block" />
                        Saya memahami dan menerima syarat dan ketentuan (tautan langsung ke S&K bahasa Indonesia) dan Kebijakan Privasi Unilever.
                    </p>
                    <div className="w-full flex justify-center my-4">
                        <PeriButton text={t("SETUJU")} onClick={() => navigate("/expert/scan")} />
                    </div>
                </div>
            </div>

        </div>

    );
};

export default LandingPage4;
